// react
import { useContext } from 'react';

// router
import { useSearchParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextContracts } from '../Project.context';

// tables
import { TableContracts } from '../../../tables/cards/TableContracts/TableContracts';

// dialogs
import { DialogAddContract } from '../../../dialogs/DialogAddContract/DialogAddContract';

// mui
import { Container, Grid, Typography } from '@mui/material';

export const Contracts = () => {
	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramDialog = searchParams.get('dialog');

	// context
	const { contracts, isLoadingContracts, paginationContracts, refetchContracts } =
		useContext(ContextContracts);

	const handleCloseDialog = () => {
		setSearchParams((params) => {
			params.delete('dialog');
			return params;
		});
	};

	return (
		<>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h2">{t('contracts')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<TableContracts
							contracts={contracts}
							frame="SUPPLIERS"
							hasExport={true}
							isLoading={isLoadingContracts}
							pagination={paginationContracts}
							refetchContracts={refetchContracts}
						/>
					</Grid>
				</Grid>
			</Container>
			<DialogAddContract
				isOpen={paramDialog === 'addContract'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchContracts();
				}}
			/>
		</>
	);
};
